export default {
  explanation: {
    id: 'cart_item_unavailable_comment',
    defaultMessage:
      'The item isn’t available anymore but there’s still plenty of affordable tech on our site. Click to find a replacement.',
  },
  button: {
    id: 'cart_unavailable_cta',
    defaultMessage: 'See available items',
  },
}
